module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navmenu/navmenu.component.css
// module id = ./src/app/components/navmenu/navmenu.component.css
// module chunks = main